<template>
  <div class="c-template_input">
    <el-input
      ref="input"
      :value="value"
      :placeholder="placeholder"
      :min="1"
      :max="max"
      :type="type"
      :key="type"
      :disabled="disabled"
      :clearable="clearable"
      :maxlength="maxlength"
      :autofocus="autofocus"
      @input="onInput"
      @change="onChange"
      v-bind="$attrs"
      @keyup.enter.native="onKeyupEnter"
      @clear="onClear"
      @focus="onFocus"
      @blur="onBlur"
    >
      <!-- 右侧插槽 -->
      <template #suffix>
        <slot name="suffix"></slot>
      </template>

      <!-- 左插槽 -->
      <template #prepend>
        <slot name="prepend"></slot>
      </template>
    </el-input>
  </div>
</template>

<script>
export default {
  name: 'EL-input',
  props: {
    value: {
      type: [String, Number],
      require: true,
      default: ''
    },
    placeholder: {
      type: String,
      default: '请输入'
    },
    maxlength: {
      type: [String, Number]
    },
    max: [Number, String],
    type: {
      type: String,
      default: 'text'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onInput(e) {
      if (this.type !== 'textarea') {
        if (e) {
          e = e.replace(/\s/g, '')
        }
      }
      this.$emit('update:value', e)
      this.$emit('on-input', e)
    },
    onChange(e) {
      if (this.type !== 'textarea') {
        if (e) {
          e = e.replace(/\s/g, '')
        }
      }
      this.$emit('on-change', e)
    },

    onKeyupEnter() {
      this.$emit('on-change', this.value)
      this.$emit('on-key-up-enter', this.value)
    },

    onClear() {
      this.$emit('on-clear')
    },

    onFocus() {
      this.$emit('on-focus')
    },

    onBlur() {
      this.$emit('on-blur')
    }
  }
}
</script>

<style lang="scss" scoped>
.c-template_input {
  width: 100%;

  ::v-deep .el-input__inner {
    width: 100%;
    &:focus {
      border-color: #4cbc9a !important;
    }
  }

  ::v-deep .el-textarea__inner {
    padding: 8px 10px;
    width: 100%;
    &:focus {
      border-color: #4cbc9a !important;
    }
  }

  ::v-deep input::placeholder {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(92, 96, 117, 0.4);
    line-height: 20px;
  }

  // 隐藏 type=number 上下小箭头
  ::v-deep input::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  ::v-deep input[type='number'] {
    -moz-appearance: textfield;
  }
  ::v-deep textarea {
    &::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 5px;
      background: #d7d7d7;
    }

    &::-webkit-scrollbar-track {
      background: #f2f2f2;
    }
  }
}
</style>
